import { ClassUtils } from "./ClassUtils";

export class LoaderUtils
{
    static readonly TAG: string = "[LoadingUtils]";

    static _loaders: { [key: string]: {loaderContainer: HTMLDivElement; domElement: HTMLElement; } } = {};


    static showLoader(pId: string): void
    {
        if (!this._loaders[pId])
        {
            console.warn(this.TAG, "No loader exists with the id: ", pId);
            console.warn(this.TAG, "You have to add a loader first using addLoader() method.");
            return;
        }

        ClassUtils.removeClass(this._loaders[pId].loaderContainer, "hide");
    }

    static hideLoader(pId: string, pDestroy: boolean = false): void
    {
        if (!this._loaders[pId])
        {
            console.warn(this.TAG, "No loader to hide with the id: " + pId);
            return;
        }

        const loader: HTMLDivElement = <HTMLDivElement>this._loaders[pId].loaderContainer;
        ClassUtils.addClass(loader, "hide");

        if (pDestroy)
        {
            setTimeout(() => this.removeLoader(pId), 1000);
        }
    }

    static addLoader(pId: string, pDomElement: HTMLElement, pImmediateShow: boolean = false): void
    {
        if (this._loaders[pId])
        {
            console.warn(this.TAG, "A loader already exists with the id: " + pId);
            return;
        }
        if (!pDomElement)
        {
            console.warn(this.TAG, "Dom element is undefined.");
            return;
        }

        const loaderContainer: HTMLDivElement = document.createElement("div");
        ClassUtils.addClass(loaderContainer, "loader-container");
        if (pImmediateShow === false)    { ClassUtils.addClass(loaderContainer, "hide"); }

        const loader: HTMLDivElement = document.createElement("div");
        ClassUtils.addClass(loader, "loader");

        loaderContainer.appendChild(loader);

        pDomElement.appendChild(loaderContainer);

        this._loaders[pId] = {loaderContainer: loaderContainer, domElement: pDomElement};
    }

    static removeLoader(pId: string): void
    {
        if (!this._loaders[pId])
        {
            console.warn(this.TAG, "No loader to remove with the id: " + pId);
            return;
        }

        const loaderContainer: HTMLDivElement = <HTMLDivElement>this._loaders[pId].loaderContainer;
        if (this._loaders[pId].domElement.contains(loaderContainer))
        {
            this._loaders[pId].domElement.removeChild(loaderContainer);
        }
        delete this._loaders[pId];
    }

}



// WEBPACK FOOTER //
// ./src/app/util/LoaderUtils.ts